/**
 * Historia 176 — CU5/CU6, T7 (S121, `03-dominio.md` §3 "Errores (verbatim)" y §6 "Mapa de
 * rechazos"). Turns what `Api_Functions.jsx` throws (`{status, data: {code, message}}`, no `data`
 * on the bodiless 403) into the i18n key Jupiter shows — by `code`, with the 403 resolved by HTTP
 * status alone (no body to read a `code` from). `INVALID_TERM_KEY`, `INVALID_TERM_VALUE` and
 * `UNEXPECTED` fall through to the same generic text (T36).
 */

const REJECTION_KEY_BY_CODE = {
  CUSTOM_LANGUAGE_NOT_FOUND: 'That custom language no longer exists',
  TERM_CHANGE_NOT_FOUND: 'That change was not found',
  TERM_PLACEHOLDERS_MISMATCH: 'The term must keep these markers: {{markers}}',
  LANGUAGE_FILE_WRITE_FAILED: 'The term could not be saved because the file could not be written on the server'
}

/**
 * @param {{status?: number, data?: {code?: string}}} error What `apiPut`/`apiPost` threw
 * @returns {string} The i18n key to show
 */
export const rejectionMessageKeyFor = (error = {}) => {
  if (error.status === 403) return 'You do not have permission to edit language texts'
  const code = error.data ? error.data.code : ''
  return REJECTION_KEY_BY_CODE[code] || 'The term could not be saved'
}

/**
 * S153: the 409 that means "the file cannot be read, nothing can be saved" — distinct from the
 * rest of the rejections, handled by putting the whole tab read-only instead of showing a message
 * here (the caller checks this before calling `rejectionMessageKeyFor`).
 *
 * @param {{status?: number, data?: {code?: string}}} error
 * @returns {boolean}
 */
export const isFileUnavailable = (error = {}) =>
  error.status === 409 && Boolean(error.data) && error.data.code === 'LANGUAGE_FILE_UNAVAILABLE'
